<page-header
    icon="{{['ADMIN', 'LABELS', 'LABELS'] | monIcons}}"
    header="{{'Labels' | translate}}"
    subHeader="{{'List of all labels' | translate}}">
    <page-header-content>
        <button
            class="btn btn-border-radius btn-secondary pull-right outer-t-small"
            (click)="addLabel()"
            monEventTrigger="actionTrigger"
            [monEventParams]="{action: 'admin-label-new'}">
            + {{'Add new label' | translate}}
        </button>
    </page-header-content>
</page-header>

<mon-panel-next
    [minSearchLength]="1"
    [search]="search"
    (onSearch)="onSearch($event)"
    [showSearch]="true">
    <panel-body>
        <table-container
            [collection]="labels"
            [progress]="promise"
            (onPageChange)="onPageChange($event)"
            (onPerPageChange)="onPageSizeChange($event)">
            <table class="table table-hover outer-b-none">
                <thead>
                    <tr>
                        <th class="col-md-36" translate>Label</th>
                        <th class="col-md-12"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let label of labels">
                        <td class="vertical-align-middle text-left">
                            <span [ngClass]="['ADMIN', 'LABELS', 'TAG'] | monIcons" class="fa-lg pull-left"></span>
                            <div class="pull-left outer-l-small label" [ngStyle]="{'background-color': label.color}">
                                <div class="label-text" [ngStyle]="{'color': (label.color | inverseColorCode)}">
                                    {{ label.name }}
                                </div>
                            </div>
                        </td>
                        <td class="text-right vertical-align-middle">
                            <div class="btn-group">
                                <button
                                    class="btn btn-border-radius btn-secondary"
                                    monEventTrigger="actionTrigger"
                                    [monEventParams]="{action: 'admin-label-delete'}"
                                    (click)="onDelete(label)">
                                    <span [ngClass]="['ADMIN', 'LABELS', 'DELETE'] | monIcons" class="outer-r-mini"></span>
                                </button>
                                <button
                                    class="btn btn-border-radius btn-secondary"
                                    (click)="editLabel(label)"
                                    monEventTrigger="actionTrigger"
                                    [monEventParams]="{action: 'admin-label-edit'}">
                                    <span [ngClass]="['ACTIONS', 'EDIT'] | monIcons" class="outer-r-mini"></span>
                                    <span translate>Edit</span>
                                </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </table-container>
    </panel-body>
</mon-panel-next>
